const ar = {
  app: {
    name: "خان بابا",
    tagline: "للحلويات والمأكولات",
  },
  nav: {
    menu: "القائمة",
    daily: "طازج اليوم",
    cart: "السلة",
    admin: "الإدارة",
  },
  common: {
    add: "أضف",
    added: "تمت الإضافة",
    remove: "إزالة",
    soldOut: "نفد",
    lowStock: "متبقٍ {{count}} فقط",
    remaining: "متبقٍ {{count}}",
    back: "رجوع",
    next: "التالي",
    confirm: "تأكيد",
    cancel: "إلغاء",
    close: "إغلاق",
    save: "حفظ",
    loading: "جارٍ التحميل…",
    search: "ابحث عن طبق…",
    all: "الكل",
    km: "كم",
    minToOrder: "الحد الأدنى",
    each: "للحبة",
    qty: "الكمية",
    viewCart: "عرض السلة",
    items: "أصناف",
    fast: "سريع",
    minutes: "دقيقة",
    popular: "الأكثر طلباً",
  },
  home: {
    heroTitle: "نكهات أصيلة، توصيل في كل الكويت",
    heroSubtitle:
      "صيني، مأكولات بحرية، برياني، صواني طازجة يومياً وحلويات — من مطابخنا في السالمية والفحيحيل إلى بابك.",
    orderNow: "اطلب الآن",
    todaysFresh: "صواني اليوم الطازجة",
    fullMenu: "القائمة الكاملة",
    dailyNote: "تُطهى بكميات كبيرة مرتين يومياً — كمية محدودة، الأسبق فالأسبق.",
    branches: "فروعنا",
    callUs: "اتصل",
    whatsapp: "واتساب",
    fastTitle: "تبغى طلبك بسرعة؟",
    fastNote: "اطلب أصناف ⚡ السريع فقط واستلم طلبك في نصف الوقت تقريباً.",
  },
  location: {
    title: "أين نوصّل طلبك؟",
    subtitle: "اختر الفرع وحدّد موقعك على الخريطة لنتحقق من المنطقة ورسوم التوصيل.",
    chooseBranch: "اختر الفرع",
    autoNearest: "أقرب فرع",
    byArea: "منطقتي",
    byPin: "الخريطة",
    pinOnMap: "اضغط على الخريطة لتحديد موقعك",
    useMyLocation: "استخدم موقعي",
    orPickArea: "أو اختر منطقتك من القائمة",
    selectArea: "اختر منطقتك",
    distanceLabel: "المسافة من {{branch}}",
    deliveryFee: "رسوم التوصيل",
    outsideArea: "عذراً — هذا الموقع خارج نطاق توصيل {{branch}} (بحد أقصى {{max}} كم).",
    tryOtherBranch: "جرّب الفرع الآخر",
    confirm: "تأكيد الموقع",
    change: "تغيير",
    deliverTo: "التوصيل إلى",
    feeVaries: "الرسوم تعتمد على المسافة وحجم الطلب — لا يوجد توصيل مجاني.",
    delivery: "توصيل",
    pickup: "استلام",
    pickupFrom: "الاستلام من",
    pickupNote: "استلم من الفرع — بدون رسوم توصيل.",
  },
  menu: {
    standingTitle: "القائمة",
    dailyTitle: "صواني اليوم الطازجة",
    dailyTag: "يومي",
    madeToOrder: "يُحضّر عند الطلب",
    emptyDaily: "لم يتم نشر قائمة اليوم بعد. تفقّدها قريباً.",
    session: { morning: "دفعة الصباح", evening: "دفعة المساء" },
  },
  cart: {
    title: "طلبك",
    empty: "سلتك فارغة.",
    browse: "تصفّح القائمة",
    subtotal: "المجموع الفرعي",
    deliveryFee: "رسوم التوصيل",
    total: "الإجمالي",
    belowMin: "أضف {{amount}} للوصول إلى الحد الأدنى {{min}}.",
    setLocation: "حدّد موقع التوصيل لرؤية الرسوم.",
    checkout: "إتمام الطلب",
    outsideArea: "موقعك خارج نطاق التوصيل.",
    eta: "وقت التوصيل",
    discount: "الخصم",
  },
  promo: {
    title: "رمز الخصم",
    placeholder: "رمز الخصم",
    apply: "تطبيق",
    remove: "إزالة",
    invalid: "هذا الرمز غير صالح.",
    expired: "انتهت صلاحية هذا الرمز.",
    belowMin: "أنفق {{min}} لاستخدام هذا الرمز.",
    noLongerValid: "الرمز {{code}} لم يعد ينطبق على هذا الطلب.",
    note: "الخصم يُطبّق على قيمة الطلب فقط — التوصيل ليس مجانياً أبداً.",
  },
  schedule: {
    title: "متى؟",
    asap: "في أقرب وقت",
    later: "حدد موعداً",
    noSlots: "لا مواعيد متبقية في هذا اليوم — اختر يوماً آخر.",
    scheduledFor: "مجدول لـ {{time}}",
    asapLabel: "في أقرب وقت ممكن",
    slotPassed: "انتهى هذا الموعد — يرجى اختيار موعد جديد.",
  },
  checkout: {
    title: "إتمام الطلب",
    contact: "بيانات التواصل",
    name: "الاسم الكامل",
    phone: "رقم الهاتف",
    addressTitle: "عنوان التوصيل",
    governorate: "المحافظة",
    area: "المنطقة",
    block: "قطعة",
    street: "شارع",
    building: "المبنى / المنزل",
    jadda: "جادة (اختياري)",
    floor: "الطابق (اختياري)",
    apartment: "الشقة (اختياري)",
    paci: "رقم العنوان الوطني (اختياري)",
    notes: "ملاحظات للسائق (اختياري)",
    payment: "طريقة الدفع",
    knet: "كي نت",
    card: "فيزا / ماستركارد",
    applepay: "آبل باي",
    cod: "الدفع عند الاستلام",
    online: "ادفع أونلاين (كي نت / بطاقات / آبل باي)",
    placeOrder: "تأكيد الطلب",
    paying: "جارٍ التحويل إلى الدفع الآمن…",
    placing: "جارٍ تنفيذ طلبك…",
    required: "يرجى تعبئة الحقول المطلوبة.",
    eta: "وقت التوصيل المتوقع",
    pickupEta: "جاهز للاستلام خلال",
    fastEta: "⚡ توصيل سريع — نصف الوقت المعتاد تقريباً",
    newAddress: "عنوان جديد",
    saveAddress: "احفظ هذا العنوان في حسابي",
    addressLabel: "التسمية (مثال: المنزل، العمل)",
  },
  confirmation: {
    title: "تم استلام طلبك!",
    thanks: "شكراً لك، {{name}}. لقد استلمنا طلبك.",
    orderNo: "رقم الطلب",
    payNow: "ادفع الآن",
    codNote: "يرجى تجهيز المبلغ نقداً للسائق.",
    statusNote: "سيتصل بك المطعم قريباً للتأكيد.",
    newOrder: "اطلب مرة أخرى",
  },
  admin: {
    title: "إدارة الموظفين",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    daily: "قائمة اليوم",
    standing: "القائمة الثابتة",
    orders: "الطلبات",
    branch: "الفرع",
    publishMorning: "نشر دفعة الصباح",
    startEvening: "بدء دفعة المساء",
    published: "تم النشر",
    addSpecial: "أضف طبق اليوم",
    scan: "مسح لوحة القائمة",
    scanning: "جارٍ قراءة الصورة…",
    scanNone: "تعذّرت قراءة الأصناف — جرّب صورة أوضح أو أضفها يدوياً.",
    scanAdded: "تمت إضافة {{count}} صنف من الصورة. راجعها ثم انشرها.",
    scanDemo:
      "تمت إضافة {{count}} صنف (مسح مبدئي على الجهاز). النسخة المباشرة تستخدم الذكاء الاصطناعي لدقة أعلى.",
    fast: "سريع",
    itemName: "الصنف (إنجليزي)",
    itemNameAr: "الصنف (عربي)",
    price: "السعر",
    qty: "الكمية",
    active: "مفعّل",
    saved: "تم الحفظ",
    ordersEmpty: "لا توجد طلبات بعد.",
    status: {
      new: "جديد",
      confirmed: "مؤكد",
      preparing: "قيد التحضير",
      out_for_delivery: "قيد التوصيل",
      delivered: "تم التوصيل",
      cancelled: "ملغى",
    },
    pay: {
      unpaid: "غير مدفوع",
      pending: "معلّق",
      paid: "مدفوع",
      failed: "فشل",
      refunded: "مسترد",
    },
    demoNote: "وضع العرض — لا يوجد اتصال بالخادم. التغييرات محلية في هذا المتصفح.",
  },
  demo: {
    banner: "عرض تجريبي — بيانات تجريبية بدون خادم مباشر.",
  },
  sheet: {
    notes: "ملاحظات خاصة",
    notesPh: "مثال: حار زيادة، بدون بصل…",
    add: "أضف إلى السلة",
    required: "مطلوب",
    optional: "اختياري",
    upTo: "حتى {{n}}",
  },
  track: {
    title: "تتبّع طلبك",
    subtitle: "تابع حالة طلبك مباشرةً.",
    enterId: "رقم الطلب (مثال KB123456)",
    find: "تتبّع الطلب",
    notFound: "لم نتمكن من إيجاد هذا الطلب — تحقق من الرقم وحاول مجدداً.",
    cancelled: "تم إلغاء هذا الطلب.",
    eta: "الوصول المتوقع",
    help: "استفسار؟ اتصل أو راسل الفرع على واتساب.",
    recent: "طلباتك الأخيرة",
    received: "تم استلام الطلب",
    preparing: "يتم تحضير طلبك",
    onway: "في الطريق إليك",
    delivered: "تم التوصيل",
  },
  account: {
    title: "حسابي",
    signInTitle: "سجّل الدخول أو أنشئ حساباً",
    signInBody: "احفظ بياناتك لإتمام الطلب بشكل أسرع ولرؤية سجل طلباتك. اختياري — يمكنك دائماً الطلب كضيف.",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    orders: "طلباتي",
    noOrders: "لا توجد طلبات بعد.",
    guestNote: "لا حاجة لحساب للطلب — تسجيل الدخول اختياري.",
    savedAddress: "العنوان المحفوظ",
    addresses: "العناوين المحفوظة",
    addAddress: "أضف عنواناً",
    noAddresses: "لا توجد عناوين محفوظة بعد.",
    reorder: "أعد الطلب",
  },
  reviews: {
    title: "ماذا يقول عملاؤنا",
    count: "{{count}} تقييم",
    leave: "أضف تقييماً",
    yourName: "اسمك",
    yourReview: "تقييمك",
    rate: "تقييمك بالنجوم",
    submit: "إرسال التقييم",
    thanks: "شكراً على تقييمك!",
  },
  footer: {
    tagline: "حلويات ووجبات طازجة، توصيل في كل الكويت.",
    hours: "مفتوح يومياً",
    directions: "الاتجاهات",
    call: "اتصل",
    orderNow: "اطلب الآن",
    rights: "جميع الحقوق محفوظة.",
  },
} as const;

export default ar;
